<template>
  <div>
    <v-menu transition="scroll-y-transition">
      <template v-slot:activator="{ props: activatorProps }">
        <div class="d-flex align-center ga-2">
          <div v-if="isConnected" class="d-flex align-center ga-1">
            <!-- Hidden on phones: the app bar needs the room, the admin menu stays in this menu -->
            <v-chip v-if="isAdmin" color="error" variant="flat" size="x-small" class="d-none d-sm-inline-flex">Admin</v-chip>
            <v-chip v-if="isMember && !isAdmin" class="ma-2 qev-badge" color="gold-tint" variant="flat" size="x-small">
              Premium
              <v-icon size="x-small" end> mdi-star </v-icon>
            </v-chip>
          </div>
          <v-btn icon v-bind="activatorProps">
            <v-icon v-if="!isConnected">mdi-account-outline</v-icon>
            <v-icon v-else>mdi-account</v-icon>
          </v-btn>
        </div>
      </template>
      <v-list style="max-height: 100vh; overflow-y: auto; top: 0">
        <v-list-item v-if="isConnected" :to="{ name: 'mon-profil' }">
          <v-list-item-title><v-icon>mdi-card-account-details-outline</v-icon> Mon profil</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="isConnected" :to="{ name: 'payment-portal' }">
          <v-list-item-title><v-icon>mdi-credit-card-clock-outline</v-icon> Mon abonnement</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!isConnected" :to="{ name: 'connexion' }">
          <v-list-item-title><v-icon>mdi-login</v-icon> Connexion</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="isConnected" @click="$emit('logout')">
          <v-list-item-title><v-icon>mdi-logout</v-icon> Déconnexion</v-list-item-title>
        </v-list-item>
        <v-divider class="my-1"></v-divider>
        <!-- @click.stop keeps the menu open so the new theme can be seen and changed again -->
        <div class="px-4 py-2" @click.stop>
          <div class="text-body-small text-medium-emphasis mb-1">Thème</div>
          <theme-selector compact></theme-selector>
        </div>
        <v-btn
          v-if="isAdmin"
          @click.stop="$emit('toggle-admin-drawer')"
          variant="flat"
          color="error"
          block
          class="justify-start"
        >
          <v-icon>mdi-cog-outline</v-icon> Admin
        </v-btn>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
  import ThemeSelector from "@/components/ThemeSelector.vue";

  export default {
    name: "AccountMenu",
    components: { ThemeSelector },
    props: {
      isConnected: {
        type: Boolean,
        default: false,
      },
      isMember: {
        type: Boolean,
        default: false,
      },
      isAdmin: {
        type: Boolean,
        default: false,
      },
      user: {
        type: Object,
        default: null,
      },
    },
    emits: ["logout", "toggle-admin-drawer"],
  };
</script>
